module.exports = {
    BASE_URL: "https://api.kiot.io/hotel/",
    BASE_URL_FOR_CHECKIN: "https://portal.kiot.io",
    MQTT_HOST: "mqtt.kiot.io",
    MQTT_PORT: "8084",
    MQTT_SECURED: true,
    MQTT_ROUTE: 'mqtt',
    prod: true
}


// WEBPACK FOOTER //
// ./environment/environment.js